import { mask } from 'remask';

export function maskCEP(value: string) {
  if (!value) return '';
  const cep = ['99999-999'];

  return mask(value, cep);
}
